import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Card,
  CardContent,
  FormControl,
  TextField,
  Typography,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import { makeStyles, MenuItem } from "@mui/material";
import { Select } from "@mui/material";
import { Col } from "reactstrap";
import { Button } from "@mui/material";

import { Row } from "reactstrap";
const validationSchema = Yup.object().shape({
  queryName: Yup.string().required("Query Name is required"),
  selected: Yup.string()
    .notOneOf(["select-role"], "Please select a role")
    .required("Role is required"),
});

const SaveNewQuery = (props) => {
  const formik = useFormik({
    initialValues: {
      queryName: props.queryName || "",
      selected: props.selected || "",
    },
    validationSchema,
    onSubmit: (values) => {
      const { queryName, selected } = values;
      // props.onSubmit({ queryName, selected }, { update: false });
    },
  });

  return (
    <Card>
      <CardContent>
        <Row>
          <Typography
            variant="h5"
            component="h5"
            style={{
              marginBottom: "16px",
              marginLeft: "2px",
              fontWeight: "bold",
              color: "#24695c",
            }}
          >
            Enter Query Details
          </Typography>
        </Row>

        <div className="mt-2 mb-5">
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <TextField
                className="mb-3"
                fullWidth
                label="Query Name"
                variant="outlined"
                name="queryName"
                value={formik.values.queryName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.queryName && Boolean(formik.errors.queryName)
                }
                helperText={formik.touched.queryName && formik.errors.queryName}
              />
            </Col>
          </Row>

          <>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                variant="outlined"
                name="selected"
                value={formik.values.selected}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                size="small"
                error={
                  formik.touched.selected && Boolean(formik.errors.selected)
                }
                // helperText={formik.touched.selected && formik.errors.selected}
              >
                <MenuItem value="select-role">Select Role</MenuItem>
                {props?.userGroup?.map((i) => {
                  return (
                    <MenuItem key={i.userGroupName} value={i.userGroupName}>
                      {i.userGroupName}
                    </MenuItem>
                  );
                })}
              </Select>
              {formik.touched.selected && formik.errors.selected ? (
                <FormHelperText sx={{ color: "#bf3333" }}>
                  {formik.touched.selected && formik.errors.selected}
                </FormHelperText>
              ) : null}
            </FormControl>
          </>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "15px",
            marginTop: "4rem",
            marginBottom: "1rem",
          }}
        >
          <div>
            <Button
              variant="contained"
              className="bg-primary"
              style={{ color: "white" }}
              onClick={() => {
                formik.handleSubmit();
                if (formik.isValid) {
                  props.onSubmit(
                    {
                      queryName: formik.values.queryName,
                      selected: formik.values.selected,
                    },
                    { update: false }
                  );
                }
              }}
              disabled={!formik.isValid}
            >
              Save New Query
            </Button>
          </div>
          <div>
            <Button
              variant="contained"
              className="bg-primary"
              style={{ color: "white" }}
              onClick={() => {
                formik.handleSubmit();

                if (formik.isValid) {
                  props.onSubmit(
                    {
                      queryName: formik.values.queryName,
                      selected: formik.values.selected,
                    },
                    { update: true }
                  );
                }
              }}
              disabled={!formik.isValid}
            >
              Update
            </Button>
          </div>
          <div>
            <Button
              variant="contained"
              onClick={() => {
                props.handleClose();
              }}
            >
              Cancel
            </Button>
          </div>
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <FormGroup>
                <FormControlLabel
                  // required
                  control={
                    <Checkbox
                      checked={props.isDefaultQuery}
                      onChange={props.handleChange}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  }
                  label="Set as Default"
                />
              </FormGroup>
            </Col>
          </Row>
        </div>
      </CardContent>
    </Card>
  );
};

export default SaveNewQuery;
